angular
  .module("app")
  .controller("FirmaDigitaleCtrl", function (
    $scope,
    $configService,
    $userService,
    $contractService

  ) {


      $scope.initialize = function () {
			/** init services **/

        $scope.popolateCertificate();
    
		  }

      $scope.filterExported = function(value){

        $scope.filters= value;
        
      }


      $scope.popolateCertificate = function(){
        $userService.getCertificatoFirma()
          .then(function(response){
            if(response.success){
              $scope.certificateIC = response.getCertFirmaResponse.certResponse.listCertificatoFirma[0];
              $scope.certificateIC.dataEmissione = moment($scope.certificateIC.dataEmissione).format("DD/MM/YYYY");
              $scope.certificateIC.dataScadenza= moment($scope.certificateIC.dataScadenza).format("DD/MM/YYYY");
            }
            
          })
      }



  });